export const faqItems = [
  {
    category: "Canadian Urban Data Catalogue",
    question: "What is the purpose of the Canadian Urban Data Catalogue (CUDC)?",
    answer: "The CUDC is an open catalogue designed to facilitate the discovery of Canadian urban datasets. It provides a structured metadata maturity model to ensure datasets are easy to search, assess, and utilize for urban research and analysis.",
  },
  {
    category: "Canadian Urban Data Catalogue",
    question: "How does the CUDC support dataset cataloguing?",
    answer: "CUDC supports dataset cataloguing through manual entry, bulk uploads, and imports from external platforms like CKAN and Dataverse. It ensures metadata consistency using its Dataset Metadata Maturity Model (DMMM).",
  },
  {
    category: "Canadian Urban Data Catalogue",
    question: "What are the metadata maturity levels in CUDC?",
    answer: "CUDC’s Dataset Metadata Maturity Model (DMMM) comprises six levels, starting from basic dataset identification and description to advanced quality metrics and statistical details, ensuring comprehensive metadata documentation.",
  },
  {
    category: "Canadian Urban Data Catalogue",
    question: "What is the role of reviews in the CUDC?",
    answer: "CUDC allows users to provide reviews on datasets to evaluate their quality across multiple dimensions. This helps enhance metadata accuracy and dataset utility for the community.",
  },
  {
    category: "Canadian Urban Data Catalogue",
    question: "How does the CUDC improve dataset search precision?",
    answer: "CUDC enhances search precision using advanced filtering based on the metadata maturity model attributes and integrating domain-specific taxonomies for structured and relevant query results.",
  },
  {
    category: "City Digital Twin Project",
    question: "What is a City Digital Twin (CDT)?",
    answer: "A City Digital Twin is a digital model of a city that represents its structure, processes, and activities for purposes such as design, planning, analysis, and operations. It aims to provide a high-fidelity model tailored to specific urban needs.",
  },
  {
    category: "City Digital Twin Project",
    question: "What are the core modules of the City Digital Twin platform?",
    answer: "The City Digital Twin platform consists of three core modules: a semantically rich city model (knowledge graph), a reasoning engine for spatial and temporal analysis, and a user interface for dashboards and SPARQL-based queries.",
  },
  {
    category: "City Digital Twin Project",
    question: "How does the City Digital Twin support Complete Communities analysis?",
    answer: "The City Digital Twin evaluates infrastructure, amenities, and services to calculate walking distances and completeness indicators, ensuring that community members are within a 15-20 minute walking distance of essential amenities.",
  },
  {
    category: "City Digital Twin Project",
    question: "What standards does the City Digital Twin use for data modeling?",
    answer: "The City Digital Twin uses standards like ISO/IEC 5087 for city data models, ISO/IEC 21972 for city indicators, and the Canadian Census Ontology to ensure semantic consistency and interoperability.",
  },
  {
    category: "City Digital Twin Project",
    question: "What are the practical applications of the City Digital Twin?",
    answer: "Applications include evaluating the impact of urban investments, analyzing UN Sustainable Development Goals, assessing environmental and social changes, and designing efficient transportation and housing systems.",
  },
  {
    category: "Jobs",
    question: "What positions are currently available at the Urban Data Centre?",
    answer: "The Urban Data Centre is seeking professionals in urban data analysis, software development, and project management. For the latest openings, please visit our [careers page](https://urbandatacentre.com/jobs).",
  },
  {
    category: "Jobs",
    question: "How can I apply for a position at the Urban Data Centre?",
    answer: "To apply, submit your resume and cover letter through the application portal on our [jobs page](https://urbandatacentre.com/jobs). Ensure your application highlights relevant experience and skills.",
  },
  {
    category: "Jobs",
    question: "What qualifications are required for roles at the Urban Data Centre?",
    answer: "Qualifications vary by position but generally include a background in urban studies, data science, computer science, or related fields. Specific requirements are detailed in each job posting on our [careers page](https://urbandatacentre.com/jobs).",
  },
  {
    category: "Jobs",
    question: "Does the Urban Data Centre offer internship opportunities?",
    answer: "Yes, the Urban Data Centre provides internships for students and recent graduates interested in urban data research. Internship openings are posted on our [jobs page](https://urbandatacentre.com/jobs) when available.",
  },
  {
    category: "Jobs",
    question: "What is the recruitment process at the Urban Data Centre?",
    answer: "Our recruitment process includes an initial application review, followed by interviews and assessments tailored to the role. Detailed information is provided during the application process on our [jobs page](https://urbandatacentre.com/jobs).",
  },
  {
    category: "How to use the dashboard",
    question: "Step #1",
    answer: 'Selecte the city for which you want to analyze data from the "City" dropdown menu. For example, if you are analyzing data for Toronto, choose "Toronto" from the list. Once the city is selected, move on to the "Administrative Area Type" dropdown to choose the type of geographic division you want to analyze, such as neighborhoods, wards, or other administrative boundaries. After selecting the area type, use the "Administrative Area Instance" dropdown to pick specific areas within that type for detailed analysis. You can select one or more areas to focus your visualization.',
  },
  {
    category: "How to use the dashboard",
    question: "Step #2",
    answer: 'Configure the indicator information. For the first indicator, use the provided dropdown to select a data point such as crime rate, population growth, or another available indicator. Set the starting and ending years for the selected indicator to define the time range of your analysis. If you want to analyze multiple indicators, click the blue + button to add additional indicators, repeating the process of selecting the indicator and its respective time range. If you need to remove an indicator, click the red trash bin button.',
  },
  {
    category: "How to use the dashboard",
    question: "Step #3",
    answer: 'Click the green "Generate Visualization" button. This will generate a detailed visualization based on your chosen parameters, including a map that highlights the selected areas, a data table displaying indicator values, and graphs (such as bar charts, pie charts, or line charts) that visually represent the data. If necessary, you can customize the charts by changing the graph types using the dropdowns beneath the charts. Additionally, a multi-indicator comparison feature allows you to select multiple indicators and compare their data in a consolidated view.',
  },
  {
    category: "How to use the dashboard",
    question: "Step #4",
    answer: 'You have the option to save your visualization using the "Save Visualization" button or close the visualization by clicking the "Close Visualization" button to return to the input form for adjustments. If an error message appears, ensure that all inputs are valid, such as choosing appropriate year ranges and ensuring data availability for the selected indicators. By following these steps, the dashboard allows for dynamic exploration and visualization of geographic and indicator-based data.',
  },
  {
    category: "General Questions",
    question: "What is University of Toronto?",
    answer: "The University of Toronto is a public research university in Toronto, Ontario, Canada, located on the grounds that surround Queen's Park. It was founded by royal charter in 1827 as King's College, the first institution of higher learning in Upper Canada.",
  },
  {
    category: "Contact Us",
    question: "By webform",
    answer: "You can visit https://urbandatacentre.com/contact-us",
  },
];
